const longDesc = document?.querySelector('.long-desc__container');
const toggleTextButton = longDesc?.querySelector("#long-desc__toggle-text");
const text = longDesc?.querySelector('.long-desc__text');
const seeLess = longDesc?.querySelector('.long-desc__see-less');
const seeMore = longDesc?.querySelector('.long-desc__see-more');
const toggle = longDesc?.querySelector('.toggle')

if (!toggleTextButton || !text) return;

function toggleText() {
  const isTextExpanded = text?.classList.contains('long-desc__text__expanded');
  
  seeLess.style.display = isTextExpanded ? 'none' : 'block';
  seeMore.style.display = isTextExpanded ? 'block' : 'none';
  text.style.webkitLineClamp = isTextExpanded ? '5' : 'unset';
  if (!isTextExpanded) text?.classList.add('long-desc__text__expanded');
  else text?.classList.remove('long-desc__text__expanded');
}

function handleTogleState() {
  if (window.innerWidth > 768) toggle?.classList.add('opened');
}

toggleTextButton.addEventListener('click', toggleText);
document.addEventListener('DOMContentLoaded', handleTogleState);